import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "contexts/ThemeContext.jsx";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Alert,
} from "reactstrap";
// core components
import SimpleHeader from "../../../components/Headers/SimpleHeader.js";
import { serverHost } from "variables/serverdata.js";

function SiteProfile() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const navigate = useNavigate();
  const [siteData, setSiteData] = useState({
    company_name: "",
    address: "",
    city: "",
    country: "",
    postal_code: "",
    created_at: "",
    client_uuid: "",
    site_uuid: null,
    domain_uuid: "",
  });
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState({
    show: false,
    success: false,
    message: "",
  });
  const [isFromSitesList, setIsFromSitesList] = useState(false);
  const [isNewSite, setIsNewSite] = useState(false);
  const [domains, setDomains] = useState([]);
  useEffect(() => {
    fetchClients();
    fetchSiteData();
    fetchDomains();
  }, []);

  const fetchClients = async () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      if (!currentUser?.dealer_uuid) {
        console.error("No dealer_uuid found");
        return;
      }

      console.log("Access Token:", currentUser.access_token);
      const client_fetch = await fetch(`${serverHost}/fetch_clients`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Access: `Bearer ${currentUser.access_token}`,
        },
      });
      if (client_fetch.response != 200)
        console.error("Error: ", client_fetch.error);
      const data = await client_fetch.json();
      console.log("Fetched:", data.data);
      setClients(data.data || []);
      console.log("Clients:", clients);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchDomains = async () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      if (!currentUser?.dealer_uuid) {
        console.error("No dealer_uuid found");
        return;
      }
      const domain_fetch = await fetch(`${serverHost}/fetch_domains`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Access: `Bearer ${currentUser.access_token}`,
        },
      });
      if (domain_fetch.response != 200)
        console.error("Error: ", domain_fetch.error);
      const data = await domain_fetch.json();
      console.log("Fetched:", data.result);
      setDomains(data.result || []);
    } catch (err) {
      console.error("Error:", err);
      setLoading(false);
    }
  };

  const fetchSiteData = async () => {
    try {
      const workingSite = JSON.parse(localStorage.getItem("addEditSite"));

      if (!workingSite) {
        navigate("/admin/companysites");
        return;
      }

      setIsFromSitesList(true);
      setIsNewSite(workingSite.isNew || false);

      setSiteData({
        company_name: workingSite.company_name || "",
        address: workingSite.address || "",
        city: workingSite.city || "",
        country: workingSite.country || "",
        postal_code: workingSite.postal_code || "",
        created_at: workingSite.created_at || new Date().toISOString(),
        client_uuid:
          workingSite.client_uuid ||
          workingSite.client?.client_uuid ||
          "",
        site_uuid: workingSite.site_uuid ?? null,
        domain_uuid: workingSite.domain_uuid || "",
      });

      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setSiteData((prev) => ({
      ...prev,
      [id.replace("input-", "")]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!siteData.company_name || !siteData.client_uuid) {
      setSaveStatus({
        show: true,
        success: false,
        message: "Site name and Client are required",
      });
      return;
    }

    try {
      let error;
      if (isNewSite) {
        // Create new site
        const insert_site = await fetch(`${serverHost}/register_site`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: siteData.company_name,
            address: siteData.address,
            city: siteData.city,
            country: siteData.country,
            postal_code: siteData.postal_code,
            client_uuid: siteData.client_uuid,
            domain_uuid: siteData.domain_uuid,
          }),
        });

        const resp = insert_site.json();
        if (insert_site.status == 200) console.log("Insertion Successful");
        else {
          console.error(resp.Error);
        }
      } else {
        // Update existing site
        const update_site = await fetch(`${serverHost}/update_site`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company_name: siteData.company_name,
            address: siteData.address,
            city: siteData.city,
            country: siteData.country,
            postal_code: siteData.postal_code,
            client_uuid: siteData.client_uuid,
            site_uuid: siteData.site_uuid,
            domain_uuid: siteData.domain_uuid,
          }),
        });

        if (!update_site.ok) {
          const error = await update_site.text();
          console.error("Update site failed ", error);
          return;
        }
      }

      if (error) {
        setSaveStatus({
          show: true,
          success: false,
          message:
            `Error ${isNewSite ? "creating" : "updating"} site: ` +
            error.message,
        });
        return;
      }

      setSaveStatus({
        show: true,
        success: true,
        message: `Site ${isNewSite ? "created" : "updated"} successfully!`,
      });

      // Navigate back after successful save
      setTimeout(() => {
        localStorage.removeItem("addEditSite");
        navigate("/admin/companysites");
      }, 1500);
    } catch (error) {
      setSaveStatus({
        show: true,
        success: false,
        message:
          `Error ${isNewSite ? "creating" : "updating"} site: ` + error.message,
      });
    }
  };

  const handleBack = () => {
    localStorage.removeItem("addEditSite");
    navigate("/admin/companysites");
  };

  if (loading) {
    return (
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="text-center">Loading...</div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <SimpleHeader
        name={isNewSite ? "New Site" : "Site Profile"}
        parentName="Company"
      />
      <Container className="mt--6" fluid>
        {saveStatus.show && (
          <Alert
            color={saveStatus.success ? "success" : "danger"}
            isOpen={saveStatus.show}
            toggle={() => setSaveStatus({ ...saveStatus, show: false })}
          >
            {saveStatus.message}
          </Alert>
        )}
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card>
              <CardHeader
                style={{
                  backgroundColor: isDark ? "#1f2937" : "#f0f0f0",
                  color: isDark ? "#e2e8f0" : "#111",
                }}
              >
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">
                      {isNewSite ? "New Site Information" : "Site Information"}
                    </h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    <Button
                      color="light"
                      onClick={handleBack}
                      size="sm"
                      className="mr-2"
                    >
                      Back to Sites
                    </Button>
                    <Button color="info" onClick={handleSave} size="sm">
                      Save
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSave}>
                  <h6 className="heading-small text-muted mb-4">
                    Site details
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-company-name"
                          >
                            Site Name *
                          </label>
                          <Input
                            id="input-company_name"
                            value={siteData.company_name}
                            onChange={handleInputChange}
                            placeholder="Site name"
                            type="text"
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-client"
                          >
                            Client *
                          </label>
                          <Input
                            id="input-client_uuid"
                            type="select"
                            value={siteData.client_uuid}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Client</option>
                            {clients.map((client) => (
                              <option
                                key={client.client_uuid}
                                value={client.client_uuid}
                              >
                                {client.company_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Address
                          </label>
                          <Input
                            id="input-address"
                            value={siteData.address}
                            onChange={handleInputChange}
                            placeholder="Address"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-city"
                          >
                            City
                          </label>
                          <Input
                            id="input-city"
                            value={siteData.city}
                            onChange={handleInputChange}
                            placeholder="City"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-country"
                          >
                            Country
                          </label>
                          <Input
                            id="input-country"
                            value={siteData.country}
                            onChange={handleInputChange}
                            placeholder="Country"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-postal-code"
                          >
                            Postal Code
                          </label>
                          <Input
                            id="input-postal_code"
                            value={siteData.postal_code}
                            onChange={handleInputChange}
                            placeholder="Postal code"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-client"
                          >
                            Domain *
                          </label>
                          <Input
                            id="input-domain_uuid"
                            type="select"
                            value={siteData.domain_uuid}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Domain</option>
                            {domains.map((domain) => (
                              <option
                                key={domain.domain_uuid}
                                value={domain.domain_uuid}
                              >
                                {domain.domain_name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      {!isNewSite && (
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-created-at"
                            >
                              Created At
                            </label>
                            <Input
                              id="input-created_at"
                              value={new Date(
                                siteData.created_at
                              ).toLocaleDateString()}
                              disabled
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default SiteProfile;
